let swiper = null;

const reviewsSection = document.querySelector('.reviews__swiper');

const observer = new IntersectionObserver((entries) => {
  if (entries[0].isIntersecting && !swiper) {

    const script = document.createElement('script');
    script.src = './dist/js/swiper-bundle.min.js';
    script.onload = () => {
      swiper = new Swiper('.reviews__swiper', {
        loop: true,
        grabCursor: true,
        spaceBetween: 20,
        slidesPerView: 1,

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },

        navigation: {
          prevEl: '.reviews__btn--prev',
          nextEl: '.reviews__btn--next',
        },

        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 28,
          },
        },

        a11y: {
          prevSlideMessage: 'Poprzednia opinia',
          nextSlideMessage: 'Następna opinia',
        },
      });
    };

    document.head.appendChild(script);
    observer.disconnect();
  }
}, { rootMargin: '200px' });

if (reviewsSection) {
  observer.observe(reviewsSection);
}